function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import InfoDialog from 'swag-client-common/components/info/info-dialog';
import { teeImagePopupSelector } from '../../../redux/product/product.selectors';
import { teeImagePopupDispatcher } from '../../../redux/tee-image-popup/tee-image-popup.dispatcher';
import classes from './tee-image-popup.scss';
const settings = {
  arrows: true,
  accessibility: true,
  autoplay: false,
  dots: false,
  className: classes.slider,
  infinite: false
};
const TeeImagePopup = ({
  images,
  shownImageIndex,
  onClose
}) => {
  const content = /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(Slider, _extends({}, settings, {
    initialSlide: shownImageIndex
  }), images.map(imageObj => imageObj.url ? /*#__PURE__*/React.createElement("div", {
    key: imageObj.url,
    className: classes.imageWrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: imageObj.url,
    alt: imageObj.alt
  })) : null)));
  return /*#__PURE__*/React.createElement(InfoDialog, {
    open: true,
    onRequestClose: onClose,
    content: content
  });
};
export const TeeImagePopupComponent = connect(teeImagePopupSelector, teeImagePopupDispatcher)(TeeImagePopup);